import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
/* eslint-disable */
import POS from './container/pos';
import Orders from './container/orders';
import OrdersHistory from './container/ordersHistory';
import Caja from './container/caja';
import CortesHistory from './container/cortesHistory';
import Card from './container/card';
import Dashbaord from './container/dashboard';
import Configuration from './container/configuration';
/* eslint-enable */

const { theme } = config;

const AuthWrapper = () => {
  const { isLoggedIn } = useSelector(state => ({
    isLoggedIn: state.auth.login,
  }));
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (!isLoggedIn) {
    return <Route path="/" component={Auth} />;
  }

  return (
    <>
      <ProtectedRoute path="/admin" component={Admin} />
      {!isAdminRoute && <Redirect to="/admin" />}
    </>
  );
};

const ProviderConfig = () => {
  const { rtl, topMenu, darkMode } = useSelector(state => ({
    darkMode: state.ChangeLayoutMode.data,
    rtl: state.ChangeLayoutMode.rtlData,
    topMenu: state.ChangeLayoutMode.topMenu,
  }));

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router>
          <div>
            <AuthWrapper />
          </div>
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
